<template>
    <span v-if="status === COMPETITOR_VERIFIED_STATUS" class="tag is-success is-small">
        {{ translate("admin_payment.competitor_verified") }}
    </span>
    <span v-else-if="status === COMPETITOR_CANDIDATE_STATUS" class="tag is-info is-small">
        {{ translate("admin_payment.competitor_candidate") }}
    </span>
    <span v-else-if="status === COMPETITOR_FAILED_VERIFICATION_STATUS" class="tag is-warning is-small">
        {{ translate("admin_payment.competitor_disqualified_verification") }}
    </span>
    <span v-else-if="status === COMPETITOR_PAYMENT_DQ_STATUS" class="tag is-danger is-small">
        {{ translate("admin_payment.competitor_disqualified_payment") }}
    </span>
</template>

<script setup lang="ts">
    import { translate } from "../Common/translations";
    import {
        COMPETITOR_CANDIDATE_STATUS,
        COMPETITOR_FAILED_VERIFICATION_STATUS,
        COMPETITOR_PAYMENT_DQ_STATUS,
        COMPETITOR_VERIFIED_STATUS,
        StatusValue,
    } from "../Common/Competitors/types";

    defineProps<{
        status: StatusValue;
    }>();
</script>
